import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const typer = (type, identifier) =>
  type && identifier ? `${type}/${identifier}/` : ''

const postApproval = ({ identifier, type, workflowId, phaseId, params }) =>
  HttpClient().post(
    `/api/v1/${typer(
      type,
      identifier
    )}workflow/${workflowId}/phases/${phaseId}/approvals`,
    { data: params.data }
  )

const createApproval =
  ({ identifier, type, workflowId, assignee, phaseId, uuid }) =>
  (dispatch) => {
    const approval = {
      assignee: {
        id: assignee.id,
      },
      uuid,
    }
    const params = serializeJSONApiData('phase-items', approval, true)
    return postApproval({
      identifier,
      type,
      workflowId,
      params,
      phaseId,
    })
      .then((response) => dispatch(loadWorkflow(response.data)))
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default createApproval
